import { render, staticRenderFns } from "./DigitalManagerGuru.vue?vue&type=template&id=fa34be28&scoped=true&"
import script from "./DigitalManagerGuru.vue?vue&type=script&lang=js&"
export * from "./DigitalManagerGuru.vue?vue&type=script&lang=js&"
import style0 from "./DigitalManagerGuru.vue?vue&type=style&index=0&id=fa34be28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa34be28",
  null
  
)

export default component.exports